import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, BrainIcon, SparklesIcon } from 'lucide-react';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function SocialProofSection() {
  return <section className="relative w-full py-24 sm:py-32" data-id="element-226">
      <div className="max-w-6xl mx-auto px-6" data-id="element-227">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-228">
          {/* Card 1 — Shamanic Wisdom */}
          <motion.div variants={cardVariants} className="group relative" data-id="element-229">
            <div className="absolute inset-0 rounded-xl bg-gradient-to-b from-purple-electric/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur-xl" data-id="element-230" />
            <div className="relative rounded-xl bg-white/[0.03] backdrop-blur-xl border border-white/[0.06] p-8 overflow-hidden" data-id="element-231">
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-purple-electric to-transparent" data-id="element-232" />
              <div className="flex flex-col items-center text-center" data-id="element-233">
                <div className="w-12 h-12 rounded-full bg-purple-electric/10 flex items-center justify-center mb-5" data-id="element-234">
                  <FlameIcon className="w-6 h-6 text-purple-electric" data-id="element-235" />
                </div>
                <p className="font-serif text-3xl font-bold text-white mb-1" data-id="element-236">
                  3.000 años
                </p>
                <p className="font-sans text-white/40 text-sm" data-id="element-237">
                  de sabiduría chamánica
                </p>
              </div>
            </div>
          </motion.div>

          {/* Card 2 — Neuroscience */}
          <motion.div variants={cardVariants} className="group relative" data-id="element-238">
            <div className="absolute inset-0 rounded-xl bg-gradient-to-b from-gold/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur-xl" data-id="element-239" />
            <div className="relative rounded-xl bg-white/[0.03] backdrop-blur-xl border border-white/[0.06] p-8 overflow-hidden" data-id="element-240">
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-241" />
              <div className="flex flex-col items-center text-center" data-id="element-242">
                <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center mb-5" data-id="element-243">
                  <BrainIcon className="w-6 h-6 text-gold" data-id="element-244" />
                </div>
                <p className="font-serif text-3xl font-bold text-white mb-1" data-id="element-245">
                  Evidencia
                </p>
                <p className="font-sans text-white/40 text-sm" data-id="element-246">
                  neurocientífica real
                </p>
              </div>
            </div>
          </motion.div>

          {/* Card 3 — Your Body */}
          <motion.div variants={cardVariants} className="group relative" data-id="element-247">
            <div className="absolute inset-0 rounded-xl bg-gradient-to-b from-astral/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur-xl" data-id="element-248" />
            <div className="relative rounded-xl bg-white/[0.03] backdrop-blur-xl border border-white/[0.06] p-8 overflow-hidden" data-id="element-249">
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-astral to-transparent" data-id="element-250" />
              <div className="flex flex-col items-center text-center" data-id="element-251">
                <div className="w-12 h-12 rounded-full bg-astral/10 flex items-center justify-center mb-5" data-id="element-252">
                  <SparklesIcon className="w-6 h-6 text-astral" data-id="element-253" />
                </div>
                <p className="font-serif text-3xl font-bold text-white mb-1" data-id="element-254">
                  Tu cuerpo
                </p>
                <p className="font-sans text-white/40 text-sm" data-id="element-255">
                  la produce naturalmente
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}